import {GedApiBack} from "./configs/Api";
import {Status} from "../models/ContractTypes";
import { SharepointStatus } from "../models/SharePointTypes";

export const ProjectStatusService = {

  /** STATUS */

  getContractStatus: async function (projectId:number) {
    const response = await GedApiBack.request({
        url: `/project/${projectId}/local/status`,
        method: "GET",
      })
    return response.data
  },

  getSharepointWorkspaceStatus: async function (projectId:number) {
    const response = await GedApiBack.request({
        url: `/project/${projectId}/sharepoint/status`,
        method: "GET",
      })
    return response.data
  },

  updateWorkspaceStatus: async function (projectId:number, status:SharepointStatus):Promise<any> {
    const response = await GedApiBack.request({
        url: `/project/${projectId}/sharepoint/status`,
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        data: {status: status },
        body: 'raw'
       
      })
    return response.data
  },

  addContractStatus: async function (projectId:number, projectStatus:Status) {
    const response = await GedApiBack.request({
        url: `/project/${projectId}/local/status`,
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        data: {status: projectStatus },
        body: 'raw'
      })
    return response.data
  },

}
